export enum AuthBackendRoutes {
  signin = 'api/v1/signin',
  getUserData = '/api/v1/getuserdata',
}
